export const LIMIT = 20
export const CAT_PROFESSION = 1


// WEBPACK FOOTER //
// ./src/pages/Profession/constants/index.js